import React, { useState, useEffect } from 'react';
import './Contestacao.css';
import { useApiKey } from '../context/ApiKeyContext';

// URL base da API - usa variável de ambiente ou fallback para produção
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://legaldoc.ikaro.com.br';

const Contestacao = () => {
  const [progressValue, setProgressValue] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [temporaryError, setTemporaryError] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [contestacaoHtml, setContestacaoHtml] = useState('');
  
  // Obter a API Key do contexto
  const { apiKey } = useApiKey();
  
  const [fileData, setFileData] = useState({
    inicialFile: null,
    subsidiosFiles: [],
    templateFile: null,
    exampleFile: null
  });
  
  const [formData, setFormData] = useState({
    lawyerName: '',
    lawyerOAB: '',
    date: '',
    additionalInfo: ''
  });
  
  useEffect(() => {
    validateForm();
  }, [fileData, formData]); // eslint-disable-line react-hooks/exhaustive-deps
  
  const handleFileChange = (e) => {
    const { id, files } = e.target;
    
    if (id === 'subsidios-files') {
      setFileData(prev => ({
        ...prev,
        subsidiosFiles: Array.from(files)
      }));
      
      // Atualizar exibição de arquivos selecionados
      const filesContainer = document.getElementById('subsidios-list');
      filesContainer.innerHTML = '';
      
      if (files.length > 0) {
        Array.from(files).forEach(file => {
          const fileChip = document.createElement('div');
          fileChip.className = 'file-chip';
          fileChip.innerHTML = `
            ${file.name}
            <span class="remove">×</span>
          `;
          filesContainer.appendChild(fileChip);
          
          // Simulação da remoção do arquivo
          fileChip.querySelector('.remove').addEventListener('click', function() {
            fileChip.remove();
            const remaining = Array.from(document.querySelectorAll('.file-chip')).map(chip => 
              chip.textContent.replace('×', '').trim()
            );
            
            setFileData(prev => ({
              ...prev,
              subsidiosFiles: prev.subsidiosFiles.filter(f => remaining.includes(f.name))
            }));
          });
        });
      }
    } else {
      // Mapear os IDs para os nomes dos campos no estado
      let fieldName;
      if (id === 'inicial-file') {
        fieldName = 'inicialFile';
      } else if (id === 'template-file') {
        fieldName = 'templateFile';
      } else if (id === 'example-file') {
        fieldName = 'exampleFile';
      }
      
      setFileData(prev => ({
        ...prev,
        [fieldName]: files.length > 0 ? files[0] : null
      }));
      
      console.log(`Arquivo ${id} selecionado:`, files[0]?.name);
    }
  };
  
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  
  const validateForm = () => {
    const { inicialFile, subsidiosFiles } = fileData;
    const { lawyerName, lawyerOAB, date } = formData;
    
    const isValid = 
      inicialFile !== null && 
      subsidiosFiles.length > 0 && 
      lawyerName.trim() !== '' && 
      lawyerOAB.trim() !== '' && 
      date !== '';
    
    setFormValid(isValid);
  };
  
  const handleProcessClick = async () => {
    // Validar os dados novamente antes de processar
    if (!formValid) return;
    
    // Verificar se a API Key está presente
    if (!apiKey) {
      setError('API Key não encontrada. Por favor, faça login novamente.');
      return;
    }
    
    // Se já existe um resultado sendo mostrado, reiniciar o processo
    if (showResult || progressValue >= 100) {
      // Limpar os estados para permitir novo processamento
      setShowResult(false);
      setCurrentStep(0);
      setProgressValue(0);
      setJobId(null);
      setContestacaoHtml('');
      setError(null);
      
      // Ocultar as barras de progresso
      document.getElementById('status-steps').style.display = 'none';
      document.getElementById('progress-container').style.display = 'none';
      
      // Pequeno delay para garantir que a interface seja atualizada
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    
    setError(null);
    setIsProcessing(true);
    setShowResult(false);
    
    // Inicialmente, não mostrar as barras de progresso ainda
    // Elas serão mostradas apenas após receber o job_id com sucesso
    
    try {
      // Preparar os dados para a API usando FormData
      const apiFormData = new FormData();
      
      // Adicionar os arquivos
      apiFormData.append('peticao_inicial', fileData.inicialFile);
      
      // Adicionar os subsídios (podem ser múltiplos arquivos)
      fileData.subsidiosFiles.forEach(file => {
        apiFormData.append('subsidios', file);
      });
      
      // Adicionar arquivos opcionais se estiverem presentes
      if (fileData.templateFile) {
        apiFormData.append('identidade_visual', fileData.templateFile);
      }
      
      if (fileData.exampleFile) {
        apiFormData.append('estilo_escrita', fileData.exampleFile);
      }
      
      // Adicionar os dados do advogado (usar o estado formData)
      apiFormData.append('nome_advogado', formData.lawyerName);
      apiFormData.append('oab_advogado', formData.lawyerOAB);
      apiFormData.append('data_documento', formData.date);
      
      // Adicionar observações se houver
      if (formData.additionalInfo) {
        apiFormData.append('observacoes', formData.additionalInfo);
      }
      
      // URL da API
      const url = `${API_BASE_URL}/doc_creator/cria_contestacao`;
      
      // Log para diagnóstico
      console.log(`Enviando solicitação para: ${url}`);
      
      // Verificar o conteúdo do formData antes de enviar (para diagnóstico)
      for (let pair of apiFormData.entries()) {
        console.log(`FormData - ${pair[0]}: `, pair[1]);
      }
      
      // Fazer a chamada para iniciar o processamento
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'api_key': apiKey
          // Não definimos o Content-Type explicitamente pois o browser
          // o ajustará automaticamente com o boundary correto para FormData
        },
        body: apiFormData
      });
      
      if (!response.ok) {
        // Tentar obter mais detalhes do erro
        try {
          const errorData = await response.json();
          throw new Error(`Erro na requisição: ${response.status} ${response.statusText}. Detalhes: ${JSON.stringify(errorData)}`);
        } catch (parseError) {
          throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
        }
      }
      
      const data = await response.json();
      
      if (!data.job_id) {
        throw new Error('Resposta inválida: job_id não encontrado');
      }
      
      const receivedJobId = data.job_id;
      console.log(`Job iniciado com sucesso! Job ID: ${receivedJobId}`);
      setJobId(receivedJobId);
      
      // Só agora que temos o job_id, mostramos as barras de progresso
      // e atualizamos os estados relacionados ao progresso
      setCurrentStep(1);
      setProgressValue(0);
      
      // Mostrar passos e barra de progresso
      document.getElementById('status-steps').style.display = 'block';
      document.getElementById('progress-container').style.display = 'block';
      
      // Iniciar polling para verificar o status do job
      console.log(`Iniciando polling para verificar o status do job ${receivedJobId}...`);
      await checkJobStatus(receivedJobId);
      
    } catch (error) {
      console.error('Erro ao processar documento:', error);
      setError(`Falha ao processar o documento: ${error.message}`);
      setIsProcessing(false);
    }
  };
  
  // Função para verificar o status do job
  const checkJobStatus = async (jobId) => {
    let isDone = false;
    let attempts = 0;
    
    while (!isDone) {
      try {
        // Esperar entre as verificações
        if (attempts > 0) {
          const waitTime = 5000; // 5 segundos entre tentativas
          console.log(`Aguardando ${waitTime/1000} segundos antes da próxima verificação...`);
          await new Promise(resolve => setTimeout(resolve, waitTime));
        }
        
        attempts++;
        
        // URL para verificar o status
        const url = `${API_BASE_URL}/doc_creator/status/${jobId}`;
        
        // Log para diagnóstico
        console.log(`Verificando status do job ${jobId} (tentativa ${attempts})...`);
        console.log(`URL: ${url}`);
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'accept': 'application/json',
            'api_key': apiKey
          }
        });
        
        // Tratar erros HTTP
        if (response.status === 404) {
          setTemporaryError(`Job não encontrado (404). Tentando novamente...`);
          setTimeout(() => setTemporaryError(null), 10000);
          continue;
        }
        
        if (response.status === 401 || response.status === 403) {
          setTemporaryError(`Erro de autenticação (${response.status}). Tentando novamente...`);
          setTimeout(() => setTemporaryError(null), 10000);
          continue;
        }
        
        if (!response.ok) {
          setTemporaryError(`Erro ao verificar status (${response.status} ${response.statusText}). Tentando novamente...`);
          setTimeout(() => setTemporaryError(null), 10000);
          continue;
        }
        
        const data = await response.json();
        console.log('Status recebido:', data);
        
        // Verificar se o trabalho está concluído
        if (data.status === 'DONE' && 
            (data.percentage && data.percentage >= 1)) {
          
          isDone = true;
          setCurrentStep(5);
          setProgressValue(100);
          setShowResult(true);
          console.log('Processamento concluído com sucesso!');
          
          if (data && data.content_html) {
            console.log('Conteúdo HTML encontrado no campo content_html');
            setContestacaoHtml(data.content_html);
          } else {
            console.warn('Documento concluído mas sem objeto result na resposta.');
          }
          
          setIsProcessing(false);
          return;
          
        } else if (data.status === 'ERROR') {
          const errorMessage = data.error || 'Erro desconhecido';
          setTemporaryError(`Erro no processamento: ${errorMessage}. Tentando novamente...`);
          setTimeout(() => setTemporaryError(null), 10000);
          continue;
        } else if (data.status === 'RUNNING') {
          const step = data.current_step || 1;
          const totalSteps = data.total_steps || 5;
          const percentage = data.percentage ? Math.round(data.percentage * 100) : 0;
          
          setCurrentStep(step);
          setProgressValue(percentage);
          console.log(`Documento em processamento... Passo: ${step}/${totalSteps}, Progresso: ${percentage}%`);
        }
      } catch (error) {
        console.error('Erro ao verificar status do job:', error);
        setTemporaryError(`Erro na verificação: ${error.message}. Tentando novamente...`);
        setTimeout(() => setTemporaryError(null), 10000);
        continue;
      }
    }
  };

  const handleDownloadDocument = async () => {
    if (!jobId) {
      setError('Não foi possível baixar o documento. ID do job não disponível.');
      return;
    }
    
    try {
      // URL para baixar o documento
      const url = `${API_BASE_URL}/doc_creator/download/${jobId}`;
      
      // Fazer a requisição
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'accept': 'application/octet-stream',
          'api_key': apiKey
        }
      });
      
      if (!response.ok) {
        throw new Error(`Erro ao baixar documento: ${response.status} ${response.statusText}`);
      }
      
      // Obter o blob do documento
      const blob = await response.blob();
      
      // Criar um link para download
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `Contestacao_${new Date().toISOString().substring(0, 10)}.docx`;
      
      // Adicionar o link ao documento, clicar nele e removê-lo
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Liberar a URL
      window.URL.revokeObjectURL(downloadUrl);
      
    } catch (error) {
      console.error('Erro ao baixar o documento:', error);
      setError(`Falha ao baixar o documento: ${error.message}`);
    }
  };
  
  const handleEditDocument = async () => {
    // O ideal seria abrir o documento diretamente no Word Online ou similar
    // Por enquanto, apenas fazemos o download
    handleDownloadDocument();
  };

  const handlePrintDocument = () => {
    if (!contestacaoHtml) {
      setError('Não foi possível imprimir. O conteúdo da contestação não está disponível.');
      return;
    }

    // Criar nova janela
    const printWindow = window.open('', '_blank');
    
    // Definir o conteúdo HTML da nova janela
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Contestação para Impressão</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              margin: 2cm;
            }
            @media print {
              body {
                margin: 0;
                padding: 2cm;
              }
            }
          </style>
        </head>
        <body>
          ${contestacaoHtml}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    
    // Garantir que todo o conteúdo seja carregado antes de acionar a impressão
    printWindow.onload = function() {
      printWindow.focus();
      printWindow.print();
    };
  };

  return (
    <div className="container">
      <header>
        <h1>eLaw GenAI</h1>
        <h2 className="subtitle">Construção Inteligente de Contestações</h2>
      </header>
      
      <div className="card">
        <h3 className="card-title">
          <i>📄</i> Arquivos Necessários
        </h3>
        
        <div className="form-group">
          <div className="file-input">
            <label className="required">Petição Inicial:</label>
            <div className="file-upload">
              <div className="file-upload-label">
                <i>📎</i>
                <span className="file-name">
                  {fileData.inicialFile ? fileData.inicialFile.name : 'Selecionar arquivo'}
                </span>
              </div>
              <input 
                type="file" 
                id="inicial-file" 
                accept=".pdf,.doc,.docx" 
                required 
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="info-text">Anexe a petição inicial do processo.</div>
        </div>
        
        <div className="form-group">
          <div className="file-input">
            <label className="required">Subsídios:</label>
            <div className="file-upload">
              <div className="file-upload-label">
                <i>📎</i>
                <span className="file-name">
                  {fileData.subsidiosFiles.length > 0 
                    ? `${fileData.subsidiosFiles.length} arquivo(s) selecionado(s)` 
                    : 'Selecionar arquivos'}
                </span>
              </div>
              <input 
                type="file" 
                id="subsidios-files" 
                multiple 
                accept=".pdf,.doc,.docx" 
                required 
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="multiple-files" id="subsidios-list"></div>
          <div className="info-text">Anexe documentos que servirão como subsídios para a contestação (contratos, e-mails, relatórios, etc).</div>
        </div>
        
        <div className="form-group">
          <div className="file-input">
            <label>Template de Estilo:</label>
            <div className="file-upload">
              <div className="file-upload-label">
                <i>📎</i>
                <span className="file-name">
                  {fileData.templateFile ? fileData.templateFile.name : 'Selecionar arquivo'}
                </span>
              </div>
              <input 
                type="file" 
                id="template-file" 
                accept=".docx" 
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="info-text">Opcional: Anexe um documento Word que servirá como base para o estilo/identidade visual.</div>
        </div>
        
        <div className="form-group">
          <div className="file-input">
            <label>Exemplo de Escrita:</label>
            <div className="file-upload">
              <div className="file-upload-label">
                <i>📎</i>
                <span className="file-name">
                  {fileData.exampleFile ? fileData.exampleFile.name : 'Selecionar arquivo'}
                </span>
              </div>
              <input 
                type="file" 
                id="example-file" 
                accept=".docx" 
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="info-text">Opcional: Anexe um documento Word como exemplo do estilo de escrita desejado.</div>
        </div>
      </div>
      
      <div className="card">
        <h3 className="card-title">
          <i>✏️</i> Informações do Advogado
        </h3>
        
        <div className="form-group">
          <label htmlFor="lawyerName" className="required">Nome completo:</label>
          <input 
            type="text" 
            id="lawyerName" 
            placeholder="Ex: Dr. João da Silva" 
            required 
            value={formData.lawyerName}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="lawyerOAB" className="required">Número da OAB:</label>
          <input 
            type="text" 
            id="lawyerOAB" 
            placeholder="Ex: 123456/SP" 
            required
            value={formData.lawyerOAB}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="date" className="required">Data da Contestação:</label>
          <input 
            type="date" 
            id="date" 
            required
            value={formData.date}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="additionalInfo">Observações adicionais:</label>
          <textarea 
            id="additionalInfo" 
            rows="4" 
            placeholder="Informações adicionais que possam ser relevantes para a construção da contestação..."
            value={formData.additionalInfo}
            onChange={handleInputChange}
          ></textarea>
        </div>
      </div>
      
      {error && (
        <div className="error-alert">
          <i className="error-icon">⚠️</i>
          <span>{error}</span>
        </div>
      )}
      
      {temporaryError && (
        <div className="error-alert temporary">
          <i className="error-icon">⚠️</i>
          <span>{temporaryError}</span>
        </div>
      )}
      
      <button 
        id="process-btn" 
        className="process-btn"
        disabled={!formValid || isProcessing}
        onClick={handleProcessClick}
      >
        {isProcessing 
          ? 'Processando...' 
          : progressValue >= 100 && showResult 
            ? 'Gerar Contestação Novamente' 
            : 'Gerar Contestação'
        }
      </button>
      
      <div className="status-steps" id="status-steps" style={{ display: currentStep > 0 ? 'block' : 'none' }}>
        {[1, 2, 3, 4, 5].map(step => (
          <div 
            key={step}
            className={`step ${currentStep === step ? 'active' : ''} ${currentStep > step || progressValue >= 100 ? 'completed' : ''}`} 
            data-step={step}
          >
            <div className="step-number">{step}</div>
            <div className="step-label">
              {step === 1 && "Analisando detalhadamente a inicial..."}
              {step === 2 && "Estudando os arquivos de subsídios..."}
              {step === 3 && "Acessando o banco de teses e jurisprudências..."}
              {step === 4 && "Elaborando as estratégias para acontestação..."}
              {step === 5 && "Criando o documento final de contestação..."}
            </div>
          </div>
        ))}
      </div>
      
      <div className="progress-container" id="progress-container" style={{ display: currentStep > 0 ? 'block' : 'none' }}>
        <div className="progress-label">
          <span id="progress-text">
            {currentStep === 1 && "Analisando detalhadamente a inicial..."}
            {currentStep === 2 && "Estudando os arquivos de subsídios..."}
            {currentStep === 3 && "Acessando o banco de teses e jurisprudências..."}
            {currentStep === 4 && "Elaborando as estratégias para acontestação..."}
            {currentStep === 5 && progressValue < 100 && "Criando o documento final de contestação..."}
            {progressValue >= 100 && "Concluído!"}
          </span>
          <span id="progress-percentage">{progressValue}%</span>
        </div>
        <div className="progress-bar">
          <div className="progress-fill" id="progress-fill" style={{ width: `${progressValue}%` }}></div>
        </div>
        
        {progressValue >= 100 && !isProcessing && (
          <div className="progress-complete">
            <p className="complete-message">Processamento finalizado com sucesso!</p>
            <p className="complete-instruction">Você pode fazer alterações nos dados acima e gerar uma nova contestação a qualquer momento.</p>
          </div>
        )}
      </div>
      
      <div className="result-container" id="result-container" style={{ display: showResult ? 'block' : 'none' }}>
        <h3 className="card-title">
          <i>✅</i> Contestação Gerada
        </h3>
        <div 
          className="document-preview" 
          id="document-preview"
          dangerouslySetInnerHTML={{ __html: contestacaoHtml || '<div style="text-align: center; padding: 50px;"><h2>Aguardando conteúdo da contestação...</h2><p>O conteúdo será exibido após o processamento completo.</p></div>' }}
        >
        </div>
        <div className="actions">
          <button 
            className="btn btn-primary" 
            id="download-btn"
            onClick={handleDownloadDocument}
          >
            Baixar Documento
          </button>
          <button 
            className="btn btn-outline" 
            id="edit-btn"
            onClick={handleEditDocument}
          >
            Editar no Word
          </button>
          <button 
            className="btn btn-print" 
            id="print-btn"
            onClick={handlePrintDocument}
          >
            Imprimir
          </button>
        </div>
      </div>
      
      <footer>
        <p>© 2025 eLaw GenAI - Todos os direitos reservados</p>
      </footer>
    </div>
  );
};

export default Contestacao; 